import { Expose } from "class-transformer";

export class UpdateProjectPhaseDto {
  @Expose()
  name: string;
}
